import { Button } from "antd";
import { useContext } from "react";
import PageLoader from "../../components/PageLoader";
import { IMAGE_BASE_URL } from "../../common/Constants";
import { AasetupContext } from ".";
import { useLocation } from "react-router-dom";
const Aaview = () => {
    const location = useLocation();
    const pagePermissions = location.state;
    const {setEditMode,isLoading,AAData} = useContext(AasetupContext);
    if(isLoading){
        return <PageLoader />
    }

    return(
        <>
            <h1 className="pt-[20px] pl-[30px] text-[20px] font-[700] mb-[20px]">AA Setup</h1>
            <div className="p-[12px_30px] flex items-center gap-[15px] justify-between border-y border-[#EAEAEA]">
                <h3 className="text-[14px] font-[600]">Approval Advice (AA) Details</h3>
                {pagePermissions?.update_permission == 1 && (
                <Button className="flex h-[unset] gap-[10px] items-center p-[6px_15px] border-[#0F59F9] text-[#0F59F9] font-[600] text-[13px]" onClick={()=>setEditMode(true)}>
                    <img src="/images/edit_ic.svg" alt="edit" />
                    Edit Details
                </Button>
                )}
            </div>
            <div className="aa_details p-[20px_30px]">
                <div className="inline-block w-[120px] h-[80px] rounded-[6px] border border-[#DEDEDE] mb-[20px]">
                    <img className="h-full w-full object-cover" src={`${IMAGE_BASE_URL}/${AAData?.logo}`} alt="logo"/>
                </div>
                <div className="mb-[10px]">
                    <label className="block text-[#787486] text-[13px]">S No:</label>
                    <div className="text-[13px]">{AAData?.sno}</div>
                </div>
                <div className="mb-[10px]">
                    <label className="block text-[#787486] text-[13px]">Name of Company:</label>
                    <div className="text-[13px]">{AAData?.company_name}</div>
                </div>
                <div className="mb-[10px]">
                    <label className="block text-[#787486] text-[13px]">UEN No:</label>
                    <div className="text-[13px]">{AAData?.uen_no}</div>
                </div>
                <div className="mb-[10px]">
                    <label className="block text-[#787486] text-[13px]">Enquires Contact No:</label>
                    <div className="text-[13px]">{AAData?.country_code} {AAData?.phone_number}</div>
                </div>
                <div className="mb-[10px]">
                    <label className="block text-[#787486] text-[13px]">Address:</label>
                    <div className="text-[13px]">{AAData?.address}</div>
                </div>
                <div className="mb-[10px]">
                    <label className="block text-[#787486] text-[13px]">Terms and Conditions:</label>
                    <div className="text-[13px] max-w-[800px]">{AAData?.terms}</div>
                </div>
            </div>
        </>
    )
}

export default Aaview;